// extracted by mini-css-extract-plugin
export default {"container":"styles_container__O+TAZ","title":"styles_title__tTsCi","buttons":"styles_buttons__6XYnA","button":"styles_button__AlrQV"};